<template>
  <div>
    <div
      style="margin: 10px; display: flex; justify-content: space-between; align-items: center; margin-right: 30px"
    >
      <div>
        <div style="font-size: 20px">
          {{ $t('orders.details') }}
          <span style="font-size: 14px; margin-left: 30px; margin-right: 10px">{{ $t('orders.distance') }}: {{ distance }}</span><a-icon @click="getDistance" v-show="!isDloading" type="reload" style="font-size: 12px; cursor: pointer" /><a-icon v-show="isDloading" type="loading" style="font-size: 12px; cursor: pointer" />
        </div>
      </div>
      <div>
        <a-space>
          <a-button key="submit" :loading="isLoading" type="primary" @click="save">{{ $t('buttons.save') }}</a-button>
          <a-button key="submit" @click="$router.back(); $store.commit('setOrderFlag', true)">{{ $t('buttons.goBack') }}</a-button>
        </a-space>
      </div>
    </div>
    <a-divider />
    <div style="position: relative;">
      <a-form-model
        style="width: 100%; display: flex; justify-content: space-between; padding-right: 40px; flex-wrap: wrap;"
        v-bind="{labelCol: { span: 8 },wrapperCol: { span: 16 }}"
        ref="ruleForm"
        :model="form"
        :rules="rules"
      >
        <div style="width: 30%" class="orderNo">
          <a-form-model-item :label="$t('orders.code')" prop="orderNo">
            <a-input v-model="form.orderNo" />
          </a-form-model-item>
        </div>
        <div style="width: 70%">
          <a-form-model-item :label="$t('common.remark')" class="note">
            <a-textarea v-model="form.note" :rows="1" />
          </a-form-model-item>
        </div>
        <div style="width: 33%;">
          <a-form-model-item :label="$t('orders.state')" required>
            <a-select v-model="form.orderState" style="width: 110%">
              <a-select-option v-for="s in status" :key="s.value">{{ s.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('orders.orderScore')" prop="orderScore">
            <a-input style="width: 110%" v-model="form.orderScore" />
          </a-form-model-item>
        </div>
        <div style="width: 33%;">
          <a-form-model-item :label="$t('orders.type')" required>
            <a-select v-model="form.orderType" style="width: 110%">
              <a-select-option v-for="t in types" :key="t.value">{{ t.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('configuration.device')" prop="deviceId">
            <a-select
              style="width: 110%"
              v-model="form.deviceId"
              show-search
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              @inputKeydown="searchDevice"
              @popupScroll="handleDevicePopupScroll"
            >
              <a-select-option @click.native="selectDevice(d)" v-for="d in devices" :key="d.id + ''">
                {{ d.name }} - {{ d.code }} - {{ d.model }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
        <div style="width: 33%;">
          <!-- <a-form-model-item label="备注：">
            <a-textarea v-model="form.note" :rows="1" />
          </a-form-model-item>-->
          <a-form-model-item :label="$t('orders.score')" prop="orderCommentScore">
            <a-input v-model="form.orderCommentScore" />
          </a-form-model-item>
          <a-form-model-item :label="$t('common.customer')" prop="customerId">
            <a-select
              disabled
              v-model="form.customerId"
              show-search
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              @inputKeydown="searchCustomer"
              @popupScroll="handleCustomerPopupScroll"
            >
              <a-select-option v-for="c in customers" :key="c.id + ''">{{ c.company }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
        <div
          style="width: 50%; display: flex; justify-content: space-between; padding-left: 52px;"
          class="inline"
        >
          <a-form-model-item style="width: 50%" :label="$t('orders.receiver')">
            <a-select
              style="width: 110%"
              show-search
              v-model="receiver.id"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              @inputKeydown="searchReceiver"
            >
              <a-select-option @click.native="selectReceiver(r)" v-for="r in receivers" :key="r.userId">{{ r.userName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item style="width: 50%" :label="$t('orders.ratio')">
            <a-input v-model="receiver.orderRate" />
          </a-form-model-item>
        </div>
        <div
          v-for="(h, i) in helpers"
          :key="h.id"
          style="width: 50%; display: flex; justify-content: space-between; padding-left: 52px;"
          class="inline"
        >
          <a-form-model-item style="width: 50%" :label="$t('orders.helper')">
            <a-tooltip>
              <template slot="title">{{ $t('buttons.delete') }}</template>
              <a-icon
                type="minus-square"
                style="position: absolute; left: -80px; top: 2px; cursor: pointer; font-size: 16px"
                @click="removeHelper(i)"
              />
            </a-tooltip>
            <a-select
              style="width: 110%"
              show-search
              v-model="h.userId"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              @inputKeydown="searchHelper"
            >
              <a-select-option @click.native="selectHelper(r, i)" v-for="r in orderHelpers" :key="r.userId">{{ r.userName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item style="width: 50%" :label="$t('orders.ratio')">
            <a-input v-model="h.ratio" />
          </a-form-model-item>
        </div>
      </a-form-model>
      <a-button
        @click="addHelpers"
        type="primary"
        style="margin-left: 126px; margin-bottom: 20px;"
      >{{ $t('orders.addHelper') }}</a-button>
    </div>
    <div class="orders">
      <a-card :title="$t('common.record')">
        <a-form-model layout="inline" style="margin-bottom: 10px">
          <a-form-model-item :label="$t('common.operationUser')">
            <a-input v-model="params.name" />
          </a-form-model-item>
          <a-form-model-item :label="$t('common.moduleChanged')">
            <a-select v-model="params.module" style="width: 120px" @chang="handleModuleChange">
              <a-select-option value="after-sale-order-edit">{{ $t('orders.orderInfo') }}</a-select-option>
              <a-select-option value="after-sale-order-state">{{ $t('orders.state') }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-show="params.module === 'after-sale-order-edit'" :label="$t('common.request')">
            <a-select v-model="params.request" style="width: 130px">
              <a-select-option value>{{ $t('common.all') }}</a-select-option>
              <a-select-option value="POST">{{ $t('buttons.add') }}</a-select-option>
              <a-select-option value="PUT">{{ $t('common.update') }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-show="params.module === 'after-sale-order-state'" :label="$t('orders.state')">
            <a-select style="width: 120px" v-model="orderState">
              <a-select-option value="">{{ $t('common.all') }}</a-select-option>
              <a-select-option v-for="s in status" :key="s.value">{{ s.text }}</a-select-option>
              <a-select-option value="cancel">{{ $t('orders.cancel') }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.startTime')">
            <a-date-picker @change="changeStartTime" />
          </a-form-model-item>
          <a-form-model-item :label="$t('common.endTime')">
            <a-date-picker @change="changeEndTime" />
          </a-form-model-item>
          <a-button type="primary" style="float: right" @click="getSystemLogList">{{ $t('buttons.search') }}</a-button>
        </a-form-model>
        <el-table
          :data="systemLogList"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: '#fafafa' }"
          v-loading="isSystemLogLoading"
          @expand-change="handleExpand"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <div style="padding: 0 50px">
                <a-spin v-show="!props.row.description"></a-spin>
                <div v-show="props.row.description" class="system_log_description">
                  <template v-if="isEditLogShow">
                    <h3 style="margin-bottom: 15px">{{ $t('common.details') }}</h3>
                    <a-row style="margin-bottom: 10px">
                      <a-col :span="6">
                        <p>{{ $t('orders.code') }}: {{ props.row.description.orderNo }}</p>
                        <p>{{ $t('orders.type') }}: {{ props.row.description.orderType }}</p>
                      </a-col>
                      <a-col :span="6">
                        <p>{{ $t('orders.state') }}: {{ props.row.description.orderState }}</p>
                        <p>{{ $t('orders.cancelState') }}: {{ props.row.description.cancelState ? $t('orders.no') : $t('orders.yes') }}</p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>{{ $t('common.customer') }}: </h4>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span="6">{{ $t('customer.company') }}: {{ props.row.description.company }}</a-col>
                      <a-col :span="6">{{ $t('orders.contactPerson') }}: {{ props.row.description.contactPerson }}</a-col>
                    </a-row>
                    <a-row style="margin-top: 20px">
                      <a-col>
                        <h4>{{ $t('configuration.device') }}: </h4>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span="6">{{ $t('common.deviceCode') }}: {{ props.row.description.deviceCode }}</a-col>
                      <a-col :span="6">{{ $t('common.deviceName') }}: {{ props.row.description.deviceName }}</a-col>
                    </a-row>
                  </template>
                  <template v-else>
                    <a-row>
                      <a-col :span="6">{{ $t('orders.ID') }}: {{ props.row.description.preemptOrderId }}</a-col>
                      <a-col :span="6">{{ props.row.description.changeLabel ? $t('orders.cancelState') : $t('orders.state') }}: {{ props.row.description.orderState }}</a-col>
                    </a-row>
                  </template>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operationUser')" prop="user.realName"></el-table-column>
          <el-table-column :label="$t('common.mobile')" prop="user.username"></el-table-column>
          <el-table-column :label="$t('common.organization')" prop="user.organizationName"></el-table-column>
          <el-table-column :label="$t('common.request')" prop="request"></el-table-column>
          <el-table-column :label="$t('common.changeTime')" prop="time"></el-table-column>
        </el-table>
        <a-pagination
          style="float: right; margin: 16px 0"
          :current="systemLogPagination.current"
          :pageSize="systemLogPagination.pageSize"
          :total="systemLogPagination.total"
          @change="handlePageChange"
        />
      </a-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getDict } from "@/api/dict";
import { searchDeviceList } from "@/api/device";
import { searchCustomerList, getCustomerById } from "@/api/customer";
import { updateOrder, searchOrderOperators, getDistance } from "@/api/order";
import { searchReceiver, distribute, searchHelper } from '@/api/operator'
import { getSystemLog } from '@/api/SystemLog'
import { nanoid } from 'nanoid';

export default {
  data() {
    return {
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
      helpers: [],
      form: {
        orderNo: "",
        orderType: "",
        orderScore: "",
        finishTime: "",
        customerId: "",
        deviceId: "",
        note: "",
        orderState: ""
      },
      rules: {
        orderNo: [
          {
            required: true,
            message: this.$t('messages.orderNo'),
            trigger: "blur"
          }
        ],
        orderType: [
          {
            required: true,
            message: this.$t('messages.orderType')
          }
        ],
        orderScore: [
          {
            required: true,
            message: this.$t('messages.orderScore'),
            trigger: "blur"
          }
        ],
        finishTime: [
          {
            required: true,
            message: this.$t('messages.finishTime')
          }
        ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.customerId')
          }
        ],
        deviceId: [
          {
            required: true,
            message: this.$t('messages.deviceId')
          }
        ],
        orderCommentScore: [
          {
            required: true,
            message: this.$t('messages.eos')
          }
        ]
      },
      status: [],
      types: [],
      customers: [],
      devices: [],
      isLoading: false,
      receiver: {
        id: '',
        orderRate: ''
      },
      systemLogList: [],
      isSystemLogLoading: false,
      systemLogPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      params: {
        sort: 'DESC',
        requestParameters: '',
        module: 'after-sale-order-edit',
        name: '',
        request: ''
      },
      receivers: [],
      orderHelpers: [],
      orderState: '',
      isEditLogShow: true,
      distance: this.$t('orders.nd'),
      isDloading: true
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    this.originHelpersData = []
    this.params.requestParameters = `"orderNo":"${this.$route.query.orderNo}\"`
    this.getTypesAndStatus();
    this.cSearchFlag = this.dSearchFlag = this.rSearchFlag = true;
    this.customerPage = this.devicePage = this.receiverPage = 1;
    this.cs = this.ds = this.rs = "";
    this.form = this.$route.query;
    this.form.orderCommentScore = "100";
    this.getCustomerAndDeviceInfo();
    this.getOperators();
    this.getSystemLogList()
    this.getHelpers()
    this.getDistance()
  },
  mounted() {
    this.searchReceiver({
      code: 'Enter',
      target: {
        value: ""
      }
    })
  },
  methods: {
    translate() {
      this.rules = {
        orderNo: [
          {
            required: true,
            message: this.$t('messages.orderNo'),
            trigger: "blur"
          }
        ],
        orderType: [
          {
            required: true,
            message: this.$t('messages.orderType')
          }
        ],
        orderScore: [
          {
            required: true,
            message: this.$t('messages.orderScore'),
            trigger: "blur"
          }
        ],
        finishTime: [
          {
            required: true,
            message: this.$t('messages.finishTime')
          }
        ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.customerId')
          }
        ],
        deviceId: [
          {
            required: true,
            message: this.$t('messages.deviceId')
          }
        ],
        orderCommentScore: [
          {
            required: true,
            message: this.$t('messages.eos')
          }
        ]
      }
      this.distance = this.$t('orders.nd')
      this.getTypesAndStatus()
    },
    addHelpers() {
      this.helpers.push({
        id: nanoid()
      });
    },
    async getDistance() {
      this.isDloading = true
      try {
        const { data } = await getDistance({
          orderId: this.$route.query.preemptOrderId
        })
        this.distance = data
      } catch(e) {
        console.log(e)
      } finally {
        this.isDloading = false
      }
    },
    async getOperators() {
      await this.searchReceiver({ code: 'Enter', target: { value: '' } })
      const { data } = await searchOrderOperators({
        preemptOrderId: this.$route.query.preemptOrderId
      });
      data.forEach(d => {
        if (d.orderRole === 1) {
          this.receiver.id = d.userId;
          this.receiver.orderRate = d.orderRate
        }
        if (d.orderRole === 2) {
          this.helpers.push({
            ...d,
            id: nanoid(),
            ratio: d.orderRate
          })
        }
      });
    },
    async getSystemLogList() {
      this.isSystemLogLoading = true
      if (this.params.module === 'after-sale-order-edit') {
        this.params.requestParameters = `"orderNo":"${this.$route.query.orderNo}\"`
      }
      if (this.params.module === 'after-sale-order-state') {
        this.params.requestParameters = `"preemptOrderId":${this.$route.query.preemptOrderId},"orderState":${this.orderState}`
        if (this.orderState === 'cancel') {
          this.params.requestParameters = `"cancelState\":1,\"preemptOrderId\":${this.$route.query.preemptOrderId}`
        }
        if (this.orderState === '') {
          this.params.requestParameters = `"preemptOrderId":${this.$route.query.preemptOrderId}`
        }
      }
      try {
        const { data } = await getSystemLog({
          current: this.systemLogPagination.current,
          pageSize: this.systemLogPagination.pageSize,
          ...this.params
        })
        this.systemLogPagination.current = data.current
        this.systemLogPagination.pageSize = data.size
        this.systemLogPagination.total = data.total
        this.systemLogList = data.records.map(r => {
          r.description = false
          r.time = moment(r.time).format('YYYY-MM-DD HH:mm:ss')
          if (r.request === 'POST') {
            r.request = this.$t('buttons.add')
          }
          if (r.request === 'PUT') {
            r.request = this.$t('common.update')
          }
          return r
        })
        this.isEditLogShow = this.params.module === 'after-sale-order-edit'
      } catch(e) {
        console.log(e)
      } finally {
        this.isSystemLogLoading = false
      }
    },
    async getCustomerAndDeviceInfo() {
      const { data } = await getCustomerById(this.form.customerId);
      this.customers.push(data);
      const device = await searchDeviceList(1, 10, {
        query: [],
        filter: [
          {
            field: "id",
            value: +this.form.deviceId
          }
        ],
        sort: []
      });
      this.devices = device.data.records;
    },
    removeHelper(i) {
      this.helpers.splice(i, 1);
    },
    async getTypesAndStatus() {
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      try {
        const {
          data: { content }
        } = await getDict(lang, "afterSaleServerItem");
        this.types = content;
        const state = await getDict(lang, "afterSaleOrderStatus");
        this.status = state.data.content;
      } catch (e) {
        console.log(e);
      }
    },
    async searchCustomer(e) {
      if (e.code === "Enter") {
        e.target.value = e.target.value.trim();
        this.cs = e.target.value;
        this.cSearchFlag = true;
        this.customerPage = 1;
        try {
          const { data } = await searchCustomerList(1, 10, {
            query: [
              {
                field: "company",
                value: this.cs
              }
            ],
            filter: [],
            sort: []
          });
          this.customers = data.records;
        } catch (e) {
          console.log(e);
        }
      }
    },
    async searchDevice(e) {
      if (e.code === "Enter") {
        e.target.value = e.target.value.trim();
        this.ds = e.target.value;
        this.dSearchFlag = true;
        this.devicePage = 1;
        const params = {
          query: [
            {
              field: 'code',
              value: this.ds
            }
          ],
          filter: [],
          sort: []
        }
        if (this.form.customerId) {
          params.filter = [
            {
              field: 'customerId',
              value: this.form.customerId
            }
          ]
        }
        try {
          const { data } = await searchDeviceList(1, 10, params);
          this.devices = data.records;
        } catch (e) {
          console.log(e);
        }
      }
    },
    async searchReceiver(e) {
      if (e.code === "Enter") {
        e.target.value = e.target.value.trim();
        this.rs = e.target.value;
        this.rSearchFlag = true;
        this.receiverPage = 1;
        try {
          const { data } = await searchReceiver({
            userName: e.target.value
          });
          this.receivers = data;
        } catch (e) {
          console.log(e);
        }
      }
    },
    async getHelpers(userName = '') {
      try {
        const { data } = await searchHelper({
          userName
        })
        this.orderHelpers = data
      } catch(e) {
        console.log(e)
      }
    },
    searchHelper(e) {
      if (e.code === "Enter") {
        e.target.value = e.target.value.trim();
        this.getHelpers(e.target.value)
      }
    },
    async handleCustomerPopupScroll(e) {
      if (this.cSearchFlag) {
        const { scrollHeight, scrollTop, clientHeight } = e.target;
        if (scrollHeight - scrollTop === clientHeight) {
          this.customerPage++;
          const { data } = await searchCustomerList(this.customerPage, 10, {
            query: [
              {
                field: "company",
                value: this.cs
              }
            ],
            filter: [],
            sort: []
          });
          this.customers = this.customers.concat(data.records);
          if (this.customers.length >= data.total) {
            this.cSearchFlag = false;
          }
        }
      }
    },
    async handleDevicePopupScroll(e) {
      if (this.dSearchFlag) {
        const { scrollHeight, scrollTop, clientHeight } = e.target;
        if (scrollHeight - scrollTop === clientHeight) {
          this.devicePage++;
          const params = {
            query: [
              {
                field: 'code',
                value: this.ds
              }
            ],
            filter: [],
            sort: []
          }
          if (this.form.customerId) {
            params.filter = [
              {
                field: 'customerId',
                value: this.form.customerId
              }
            ]
          }
          const { data } = await searchDeviceList(this.devicePage, 10, params);
          this.devices = this.devices.concat(data.records);
          if (this.devices.length >= data.total) {
            this.dSearchFlag = false;
          }
        }
      }
    },
    async save() {
      this.$refs.ruleForm.validate(async valid => {
        let result = +this.receiver.orderRate
        for (let i = 0; i < this.helpers.length; i++) {
          result += +this.helpers[i].ratio
        }
        if (result > 100) {
          return this.$message.warn(this.$t('orders.rse'))
        }
        if (valid) {
          this.isLoading = true;
          try {
            const { message } = await updateOrder(this.form);
            if (this.receiver.id) {
              const os = []
              const orderId = this.$route.query.preemptOrderId
              os.push({
                orderId,
                userId: this.receiver.id,
                orderRole: 1,
                orderRate: this.receiver.orderRate
              })
              for (let i = 0; i < this.helpers.length; i++) {
                const h = this.helpers[i]
                os.push({
                  orderId,
                  userId: h.userId,
                  orderRole: 2,
                  orderRate: h.ratio
                })
              }
              await distribute(os)
            }
            this.$message.success(message);
          } catch (e) {
            console.log(e);
          } finally {
            this.isLoading = false;
          }
        }
      })
    },
    async handleExpand(row) {
      row.expanded = !row.expanded
      if (row.expanded && !row.description) {
        let d = JSON.parse(row.requestParameters)
        try {
          if (this.params.module === 'after-sale-order-edit' && d?.order) {
            d = d?.order || {}
            const { data } = await getCustomerById(d.customerId)
            d.company = data.company
            d.contactPerson = data.contactPerson
            const device = await searchDeviceList(1, 10, {
              query: [],
              filter: [
                {
                  field: 'id',
                  value: d.deviceId
                }
              ],
              sort: []
            })
            d.deviceCode = device.data.records[0].code
            d.deviceName = device.data.records[0].name
            d.orderType = (!d.orderType && d.orderType !== 0) ? '' : this.types[d.orderType].text
          }
          if (d.cancelState) {
            d.orderState = this.$t('orders.no')
            d.changeLabel = true
          } else {
            d.changeLabel = false
            if (!d.orderState && d.orderState !== 0) {
              d.orderState = this.status[0].text
            } else {
              d.orderState = this.status.find(s => s.value == d.orderState).text
            }
          }
        } catch(e) {
          console.log(e)
        }
        row.description = d
      }
    },
    handlePageChange(page) {
      this.systemLogPagination.current = page
      this.getSystemLogList()
    },
    selectReceiver(r) {
      if (r.userId === this.receiver.id) return
      this.receiver.orderRate = r.ratio
      this.helpers = r.assistant.map(a => {
        return {
          ...a,
          id: nanoid()
        }
      })
    },
    selectHelper(r, i) {
      this.helpers[i] = {
        id: this.helpers[i].id,
        ...r
      }
    },
    handleModuleChange(value) {
      if (value === "after-sale-order-edit") {
        this.orderStateRecord = this.orderState
        this.orderState = ''
        this.params.request = this.requestRecord || "";
        this.params.requestParameters = `"orderNo":"${this.$route.query.orderNo}\"`
      }
      if (value === "after-sale-order-state") {
        this.orderState = this.orderStateRecord || ''
        this.requestRecord = this.params.request;
        this.params.request = "";
        this.params.requestParameters = `"orderNo":"${this.$route.query.orderNo}\"`
      }
    },
    changeStartTime(date, dateString) {
      if (date) {
        this.params.startTime = +new Date(dateString);
      } else {
        delete this.params.startTime;
      }
    },
    changeEndTime(date, dateString) {
      console.log(date, dateString);
      if (date) {
        this.params.endTime = +new Date(dateString) + 24 * 3600 * 1000 - 1;
      } else {
        delete this.params.endTime;
      }
    },
    selectDevice(d) {
      this.customers = [d.customer]
      this.form.customerId = d.customerId + ''
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-form {
  padding-bottom: 0;
  &.inline {
    .ant-form-item:last-child .ant-form-item-label {
      width: 15%;
      margin-right: 6px;
    }
  }
}
.orders {
  background-color: #f5f4f7;
  padding: 10px;
}
/deep/ .ant-form {
  .orderNo {
    .ant-form-item-label {
      width: 37%;
    }
    .ant-form-item-control-wrapper {
      width: 63%;
    }
  }
  .note {
    .ant-form-item-label {
      width: 10%;
    }
    .ant-form-item-control-wrapper {
      width: 90%;
    }
  }
}
</style>